/* ═══════════════════════════════════════════════════════════════
   downloadApp — resolve and start the latest Windows installer.

   Public releases live in the SpecForma-Releases repo with versioned
   asset names (specforma-Setup-x.y.z.exe), so there is no stable
   direct URL: we ask the GitHub API for the latest release and
   navigate to its .exe asset. Any failure falls back to opening the
   releases page so the button is never a dead end.
   ═══════════════════════════════════════════════════════════════ */

export const RELEASES_LATEST_URL =
  'https://github.com/jmoneybigman/SpecForma-Releases/releases/latest';

const LATEST_API_URL =
  'https://api.github.com/repos/jmoneybigman/SpecForma-Releases/releases/latest';

/** Start downloading the latest Windows installer. Resolves when the
 *  download has been kicked off (or the fallback page opened). */
export async function downloadLatestInstaller(): Promise<void> {
  try {
    const res = await fetch(LATEST_API_URL);
    if (!res.ok) throw new Error(`GitHub API ${res.status}`);
    const release = await res.json();
    const exe = (release.assets || []).find((a: { name: string }) =>
      a.name.toLowerCase().endsWith('.exe')
    );
    if (!exe) throw new Error('No Windows installer in latest release');
    // Navigating to the asset URL triggers the browser download without
    // leaving the page.
    window.location.href = exe.browser_download_url;
  } catch {
    window.open(RELEASES_LATEST_URL, '_blank', 'noopener,noreferrer');
  }
}
